import { MDBContainer } from "mdb-react-ui-kit";

import "react-datepicker/dist/react-datepicker.css";
import { Modal, Box, IconButton, TableContainer } from "@mui/material";
import React, { useState, useEffect } from "react";
import CloseIcon from "@mui/icons-material/Close";
// import "../PassportDetails.css";  // was ../, now ./ (same folder)
import "../../PassportDetails.css";
import "datatables.net";
import { BounceLoader } from "react-spinners";
// import { dummy_Pilgrims } from "../API/data/dummy_data"; // was ../../, now ../
import Select from "react-select";

import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  Button,
} from "@mui/material";

import { useSelector } from "react-redux";
// import { makePostRequest } from "../API"; // was ../../, now ../
import { SendPostRequest } from "../../ApiRequest";
import SelectPligramComponents from "../SelectPligramComponents";
import { data } from "jquery";
import { message } from "antd";

function AllowHotalModal({ heading, open, setOpen, sendDataToModal ,setSendDataToModal,setSelectedActions,setFormVisible}) {
  const handleClose = () => {
    setOpen(false);
  };

  const [expandedRows, setExpandedRows] = useState([]);
  const [selectedPligrams, setSelectedPligrams] = useState([]);

  const toggleExpansion = (index) => {
    const newExpandedRows = [...expandedRows];
    newExpandedRows[index] = !newExpandedRows[index];
    setExpandedRows(newExpandedRows);
  };
  const [selectState, setSelectState] = useState({});
  const [metadata, setMetadata] = useState({});
  // for errors State

  const [errorState, setErrorState] = useState({});
  const [modalOpen, setModalOpen] = useState(false);
  const [mainStateData, setMainStateData] = useState({
    pilgrims: [],
    records: [],
    select: [],
    pilgrim_meta: [],
    hidden: [],
    meta:[],
    rest: {},

  });

  const [pilgremError, setPilgremError] = useState(false);

  const [hiddenState, setHiddenState] = useState();

  // dynamic State

  const openModal = () => {
    setModalOpen(true);
  };

  // states for seprating data

  useEffect(() => {
    let dynamicSelects = {};
    let dynamicInputs = {};

    // ✅ Handle selects
    if (mainStateData?.select) {
      dynamicSelects = Object.values(mainStateData.select).reduce(
        (acc, selectObj) => {
          const preSelected = selectObj.options?.find((opt) => opt.selected); // find selected:true
          acc[selectObj.name] = preSelected ? preSelected.id : ""; // store only ID
          return acc;
        },
        {}
      );
    }

    // ✅ Handle inputs
    if (mainStateData?.pilgrim_meta) {
      dynamicInputs = mainStateData.pilgrim_meta.reduce((acc, item) => {
        acc[item.name] = item.value ?? "";
        return acc;
      }, {});
    }



    // ✅ Merge into one state
    setSelectState((prev) => ({
      ...prev,
      ...dynamicSelects,
      ...dynamicInputs,
    }));


  }, [mainStateData]);

  // old  inputs 
  // useEffect(() => {
  //   let dynamicInputs = {};

  //   if (mainStateData?.pilgrim_meta) {
  //     dynamicInputs = mainStateData.pilgrim_meta.reduce((acc, item) => {
  //       acc[item.name] = item.value ?? ""; // initialize with API value
  //       return acc;
  //     }, {});
  //   }

  //   setSelectState((prev) => ({
  //     ...prev,
  //     ...dynamicInputs,
  //   }));
  // }, [mainStateData?.pilgrim_meta]);


// new inputs 

useEffect(() => {
  if (!mainStateData?.pilgrim_meta) return;

  const dynamicInputs = mainStateData.pilgrim_meta.reduce((acc, item) => {
    const name = item.name?.toLowerCase() || "";

    // if name contains "arrival-time" and no value
    if (
      name.includes("arrival-time") &&
      (item.value === null || item.value === undefined || item.value === "")
    ) {
      // current PC time in HH:MM
      const now = new Date();
      const hh = String(now.getHours()).padStart(2, "0");
      const mm = String(now.getMinutes()).padStart(2, "0");
      acc[item.name] = `${hh}:${mm}`;
    } else {
      acc[item.name] = item.value ?? "";
    }
    return acc;
  }, {});

  setSelectState((prev) => ({
    ...prev,
    ...dynamicInputs,
  }));
}, [mainStateData?.pilgrim_meta]);



















  useEffect(() => {
    if (mainStateData?.hidden) {
      const hiddenObj = mainStateData.hidden.reduce((acc, item) => {
        acc[item.name] = item.value;
        return acc;
      }, {});
      setHiddenState(hiddenObj);
    }

      if (mainStateData?.meta) {
      const metaObj = mainStateData.meta.reduce((acc, item) => {
        acc[item.name] = item.value;
        return acc;
      }, {});
       setMetadata(metaObj);
    } 





  }, [mainStateData]);

  useEffect(() => {
    let errors = {};

    // errors for selects
    if (mainStateData?.select) {
      Object.values(mainStateData.select).forEach((selectObj) => {
        errors[selectObj.name] = ""; // no error initially
      });
    }

    // errors for inputs
    if (mainStateData?.pilgrim_meta) {
      mainStateData.pilgrim_meta.forEach((item) => {
        errors[item.name] = ""; // no error initially
      });
    }

    setErrorState(errors);
  }, [mainStateData]);

  //  for Validation Error

  const validateForm = () => {
    let newErrors = {};
    let isValid = true;

    // ✅ validate selects
    if (mainStateData?.select) {
      Object.values(mainStateData.select).forEach((selectObj) => {
        const value = selectState[selectObj.name];

        if (value === "" || value === null || value === undefined) {
          newErrors[selectObj.name] = `${
            selectObj.label || selectObj.name
          } is required`;
          isValid = false;
        } else {
          newErrors[selectObj.name] = "";
        }
      });
    }

    // ✅ validate inputs
    if (mainStateData?.pilgrim_meta) {
      mainStateData.pilgrim_meta.forEach((item) => {
        const value = selectState[item.name];

        if (value === "" || value === null || value === undefined) {
          newErrors[item.name] = `${item.label || item.name} is required`;
          isValid = false;
        } else {
          newErrors[item.name] = "";
        }
      });
    }

    setErrorState(newErrors);
    return isValid;
  };




const [submitionLoding,setSubmitionLoading]=useState(false)
const [topError,setTopError]=useState(false)

  const handleSubmit = async (e) => {

    e.preventDefault();
    setTopError(false)
    if (!validateForm()) {

      console.log("❌ Validation failed");
      setTopError(true)
      return;
    }

  if (selectedPligrams.length === 0) {
    setPilgremError(true);
    return; // stop immediately
  } else {
    setPilgremError(false); // clear any previous error
  }



  setSubmitionLoading(true)
    

// FROM API THAT IS USED FOR SHOW 
const { actual_param, key,voucher_id ,record_id, reference_type} = sendDataToModal;
// for Hiden States 
const hidden_meta = Object.entries(hiddenState || {}).reduce((acc, [name, value]) => {
  acc[name] = value;
  return acc;
}, {});
// For Meta_Pilgrams  selects and inputs 
const pilgram_meta_main = Object.entries(selectState).reduce((acc, [name, value]) => {
  acc[name] = value;
  return acc;
}, {});
// for Meta data
const Main_Meta = Object.entries(metadata).reduce((acc, [name, value]) => {
  acc[name] = value;
  return acc;
}, {});

// FOR GETTING API KEYS iD
const pilgrim_id = selectedPligrams?.map(p => p.id);

// FRO GETTING CONTACTNumber of all data 
const contact_number = {
  [key]: selectedPligrams.reduce((acc, pilgrim) => {
    acc[pilgrim.id] = pilgrim.contact;
    return acc;
  }, {})
};


//FRO GETTING Check In PilgrimType of all data 

const CheckPilgrimType = {
  [key]: selectedPligrams.reduce((acc, pilgrim) => {
    acc[pilgrim.id] = pilgrim.PilgrimType;
    return acc;
  }, {})
};




// pilgram_meta_main.push(...Main_Meta);
const payload = {
  pilgrim_meta: {...pilgram_meta_main,...Main_Meta},
};

const newPayload = {  key, ...payload,voucher_id,record_id,
  ...hidden_meta ,  pilgrim_id,contact_number,CheckPilgrimType, reference_type
};
    

console.log("✅ newPayload",newPayload);






try {
  
      const endpoint = "api/umrah/activity/status/store";
      const response = await SendPostRequest(endpoint, newPayload);
      window.scrollTo({ top: 0, behavior: "smooth" });
      message.success(response?.data?.message || "Form submitted successfully");
      resetFormStates();
      handleClose();
} catch (error) {
  
  console.error("Error submitting form:", error?.message || error);
}
finally{
setSubmitionLoading(false)
}



  };


// this is for table data
const [recordsData, setRecordsData] = useState([]);
const [tableHeaders, setTableHeaders] = useState([]);






const fetchData3 = async () => {
  const endpoint = "api/umrah/activity/show";

  try {
    setLoading(true);
    const response = await SendPostRequest(endpoint, sendDataToModal);
    console.log(response.data.records);
    setLoading(false);

    if (response && response.data && response.data.records) {
      const { pilgrims, records, select, input, ...rest } = response.data;

      // Save arrays into state
      setMainStateData({
        pilgrims: pilgrims || [],
        records: records || [],
        select: select || [],
        pilgrim_meta: input?.pilgrim_meta || [],
        hidden: input?.hidden || [],
        meta: input?.meta || [],
        rest: rest || {},
      });

      setModalData(response.data);
      setTableData3(records || []);
      setRecordsData(records || []);

      // ✅ Generate dynamic headers from API
      if (records && records.length > 0) {
        const rawHeaders = Object.keys(records[0]);

        // Optional: reorder or filter some columns
        const orderedHeaders = [
          "sr", // force "sr" to be first
          ...rawHeaders.filter(
            (h) => h !== "sr" && h !== "action" // remove action column
          ),
        ];

        // Format headers for UI
        const formattedHeaders = orderedHeaders.map((key) => ({
          key,
          label: key
            .replace(/_/g, " ")
            .replace(/\b\w/g, (char) => char.toUpperCase()),
        }));

        setTableHeaders(formattedHeaders); // <-- new state for headers
      }
    }
  } catch (error) {
    console.error("Error fetching data:", error);
  }
};







  useEffect(() => {
    fetchData3();
  }, [sendDataToModal]);


  // this table data 3 will be used at grid
  const [tableData3, setTableData3] = useState([]);
  const [modalData, setModalData] = useState([]);
  const [loading, setLoading] = useState(false);

  // api will be added here

  // reset function
  const resetFormStates = () => {
    // Reset mainState in one go
    const initialMainState = {
  pilgrims: [],
  records: [],
  select: [],
  pilgrim_meta: [],
  hidden: [],
  meta: [],
  rest: {},
};

    setSelectedPligrams([]);
    setErrorState({});
    setSelectState({});
    setHiddenState({});
     setMetadata([]);
     setSelectedActions({})
     setSendDataToModal(null)
     setMainStateData(initialMainState);
     setFormVisible(false)
     setPilgremError(false)

  };

  // consoles
  // console.log("tableData3>>>>",tableData3 );
// console.log("sendDataToModal",sendDataToModal );
  // console.log("mainState>>>>", mainState);
  // console.log("selectedPligrams>>>>", selectedPligrams);
  // console.log("errorState",errorState)
  // console.log("selectState", selectState);
  // console.log("hiddenState", hiddenState);
  // console.log("mainStateData",mainStateData)
  // console.log("metadata",metadata)
  // console.log("modalData?.pilgrims", modalData?.pilgrims);
  // console.log("metadata",metadata)



  // console.log("recordsData",recordsData)
  console.log("pilgremError",pilgremError)
  console.log("selectedPligrams",selectedPligrams.length)
  return (
    <>
      <Modal
        open={open}
        key={open ? "modal-open" : "modal-closed"}
        onClose={(event, reason) => {
          if (reason !== "backdropClick") {
            handleClose();
            resetFormStates();
          }
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            ...style,
            maxHeight: "90vh", // Limit height to viewport
            overflow: "auto", // Hide overflow from parent
            display: "flex",
            flexDirection: "column",
          }}
        >
          <IconButton
            onClick={() => {
              handleClose();
              resetFormStates();
            }}
            sx={{ position: "absolute", top: 8, right: 8 }}
          >
            <CloseIcon />
          </IconButton>

          <div>
            <MDBContainer breakpoint=" p-4">
              <div className="main-wrapper">
                <div>
                  <h1 className="main-hading">
                    {" "}
                    Change voucher pilgrim status to{" "}
                    {mainStateData?.rest?.change_voucher_pilgrim_status_to}
                  </h1>

                  <h2 className="mt-4">
                    Voucher Code :{" "}
                    <span className="textColorClass">
                      {modalData?.voucher_code}
                    </span>
                  </h2>

                  {/* <AllowHotelGridFilter /> */}
                  <form>
                    <h2 style={{ marginTop: "20px" }}>
                      Kindly fill this fields
                    </h2>

                    {/* if needed */}

                    <h4 className="mt-4">
                      Voucher Start Date:
                      <span className="textColorClass ml-2">
                        {" "}
                        {modalData?.voucher_start_date}
                      </span>
                    </h4>

                    <h4 className="mt-4">
                      Voucher End Date:
                      <span className="textColorClass">
                        {" "}
                        {modalData?.voucher_end_date}
                      </span>
                    </h4>

                    {/* Dynamically created select options */}
                    {/* Select Options: */}
                    <>
       
       {/* select  */}

                      {Object.values(mainStateData?.select || {}).map(
                        (selectObj) => (
                          <div key={selectObj.name} className="mb-3">
                            <label
                              htmlFor={selectObj.name}
                              className="furas-input-label mt-3 mb-2"
                            >
                              {selectObj.label}{" *"}
                            </label>

                            <div className="row furas-dropdown">
                              <Select
                                options={
                                  selectObj.options?.length > 0
                                    ? selectObj.options.map((opt) => ({
                                        value: opt.id,
                                        label: opt.name,
                                      }))
                                    : [{ value: "", label: "No data found" }]
                                }
                                value={
                                  selectObj.options
                                    ?.map((opt) => ({
                                      value: opt.id,
                                      label: opt.name,
                                    }))
                                    .find(
                                      (o) =>
                                        o.value === selectState[selectObj.name]
                                    ) || null
                                }
                                onChange={(selectedOption) =>
                                  setSelectState((prev) => ({
                                    ...prev,
                                    [selectObj.name]:
                                      selectedOption?.value ?? "", // ✅ store only ID
                                  }))
                                }
                                styles={customStyles}
                              />
                            </div>

                            {/* 🔹 Show error if exists */}
                            {errorState[selectObj.name] && (
                              <div
                                className="text-danger mt-1"
                                style={{ fontSize: ".875em" }}
                              >
                                {errorState[selectObj.name]}
                              </div>
                            )}
                          </div>
                        )
                      )}
                    </>

                    {/* Input Fields: old  */}
                    {/* <>
                      {mainStateData?.pilgrim_meta?.map((field) => (
                        <div
                          key={field.name}
                          className="mb-3 row furas-dropdown px-2-1 mb-1"
                        >
                          <label
                            htmlFor={field.name}
                            className="furas-input-label mt-3 mb-2"
                          >
                            {field.label || field.name.replace(/-/g, " ")} {" *"}
                          </label>
                          <input
                            type={field.type || "text"}
                            id={field.name}
                            value={selectState[field.name] || ""}
                            onChange={(e) =>
                              setSelectState((prev) => ({
                                ...prev,
                                [field.name]: e.target.value,
                              }))
                            }
                            className={`px-2 ${
                              errorState[field.name] ? "is-invalid" : ""
                            }`}
                          />
                          {errorState[field.name] && (
                            <div className="invalid-feedback">
                              {errorState[field.name]}
                            </div>
                          )}
                        </div>
                      ))}
                    </> */}


{/* new input field */}

<>
  {mainStateData?.pilgrim_meta?.map((field) => (
    <div
      key={field.name}
      className="mb-3 row furas-dropdown px-2-1 mb-1"
    >
      <label
        htmlFor={field.name}
        className="furas-input-label mt-3 mb-2"
      >
        {field.label || field.name.replace(/-/g, " ")} {" *"}
      </label>

      <input
        type={field.type || "text"}
        id={field.name}
        min={field.type === "number" ? 0 : undefined}
        value={selectState[field.name] ?? ""}
        onChange={(e) => {
          let value = e.target.value;

          // only block negatives, but keep string so leading zeros work
          if (field.type === "number") {
            // disallow "-" at start
            if (value === "-") {
              value = "";
            }
            // if value starts with "-", clamp to empty or "0"
            if (value.startsWith("-")) {
              value = "0";
            }
          }

          setSelectState((prev) => ({
            ...prev,
            [field.name]: value,
          }));
        }}
        onBlur={(e) => {
          // optional: clean up value on blur to ensure it's a proper number >= 0
          if (field.type === "number") {
            const num = Number(e.target.value);
            if (!isNaN(num) && num < 0) {
              setSelectState((prev) => ({
                ...prev,
                [field.name]: "0",
              }));
            }
          }
        }}
        className={`px-2 ${errorState[field.name] ? "is-invalid" : ""}`}
      />

      {errorState[field.name] && (
        <div className="invalid-feedback">{errorState[field.name]}</div>
      )}
    </div>
  ))}
</>




















                    {/* first main row work ended ------------------------------------------ */}

                    {mainStateData?.pilgrims.length > 0 && (
                      <SelectPligramComponents
                        mainHeading="Select Pilgrims"
                        data={modalData?.pilgrims}
                        setSelectedPligrams={setSelectedPligrams}
                        selectedPligrams={selectedPligrams}
                      />
                    )}

                    {/* submition  */}
                    <div
                      className="row furas-inputs mt-4"
                      style={{ marginBottom: "30px" }}
                    >
                      <button
                        type="submit"
                        className="submit-btn"
                        // onClick={SubmitingFunction}
                        onClick={handleSubmit}
                        disabled={mainStateData?.pilgrims.length === 0 }
                      >
                        {
                          submitionLoding ==true ? "Loading..." : "Submit"
                        }
                        

                      </button>
                      
                      
 {pilgremError && <div className="text-danger mt-4">Please select at least one pilgrim</div>}

 {topError && <div className="text-danger mt-4">Please fill all the above Fields</div>}

                    </div>









                  </form>
                  {/* <div>
                                <div className="qr-wrapper">
                                    <img className=""
                                        src="scane.svg" alt="scane" />
                                    <h6>Request Camera Permission</h6>
                                    <p>Scan an image file</p>
                                </div>
                                <h4 style={{ textAlign: "center" }}>Scan to get result</h4>
                            </div> */}

                  <h4 className="header-plagrims">Pilgrims Grid</h4>
                  <div
                    style={{
                      width: "100%",
                      marginBottom: "40px",
                      paddingBottom: "10px",
                    }}
                  >
                    <TableContainer
                      sx={{
                        overflowX: "scroll", // force scroll, not auto
                        scrollbarWidth: "thin", // Firefox
                        "&::-webkit-scrollbar": {
                          height: 12, // make scrollbar thicker
                        },
                        "&::-webkit-scrollbar-thumb": {
                          backgroundColor: "#888", // scrollbar color
                          borderRadius: 6,
                        },
                        "&::-webkit-scrollbar-thumb:hover": {
                          backgroundColor: "#555",
                        },
                      }}

                      
                    >
                      <Table
                        id="example"
                        className="table table-striped dt-responsive nowrap table-display w-100 my-4"
                        sx={{
                          tableLayout: "auto", // <-- don't stretch columns equally
                          minWidth: 650, // set a base so scrolling can happen
                        }}
                      >
                       <TableHead>
  <TableRow>
    {tableHeaders.map((col) => (
      <TableCell key={col.key} sx={{ fontWeight: "bold", whiteSpace: "nowrap" }}>
        {col.label}
      </TableCell>
    ))}
  </TableRow>
</TableHead>
                      
<TableBody>
  {loading ? (
    <TableRow>
      <TableCell colSpan={tableHeaders.length} align="center" style={{ height: "20vh" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
          }}
        >
          <BounceLoader className="BouncingLoader" />
        </div>
      </TableCell>
    </TableRow>
  ) : tableData3.length === 0 ? (
    <TableRow>
      <TableCell
        colSpan={tableHeaders.length}
        align="center"
        style={{
          padding: "40px 0px",
          fontSize: "15px",
          fontWeight: "bold",
          minWidth: 650,
        }}
      >
        No data found
      </TableCell>
    </TableRow>
  ) : (
    tableData3.map((item, index) => (
      <React.Fragment key={index}>
        {/* Main Row */}
        <TableRow 
        // onClick={() => toggleExpansion(index)}
        >
          {tableHeaders.map((col) => (
            <TableCell
              key={col.key}
              sx={{ cursor: "pointer", fontWeight: col.key === "sr" ? "bold" : "normal" }}
            >
              {item[col.key]}
            </TableCell>
          ))}
        </TableRow>

        {/* Expanded Row (dynamic) */}
        {expandedRows[index] && (
          <TableRow>
            <TableCell colSpan={tableHeaders.length}>
              <div className="row">
                {tableHeaders.map((col, idx) => (
                  <div key={idx} className="col-6 d-flex flex-column">
                    <b>{col.label}:</b> {item[col.key] || "--"}
                  </div>
                ))}
              </div>
            </TableCell>
          </TableRow>
        )}
      </React.Fragment>
    ))
  )}
</TableBody>


                      </Table>
                    </TableContainer>

                    <button
                      id="btnreset"
                      type="button"
                      className="btn btn-danger  fs-1"
                      style={{ padding: "6px 20px", marginTop: "30px" }}
                      onClick={() => {
                        resetFormStates();
                        handleClose();
                      }}
                    >
                      Close
                    </button>

                    <div style={{ marginBottom: "40px" }}></div>
                  </div>
                </div>
              </div>
            </MDBContainer>
          </div>
        </Box>
      </Modal>
    </>
  );
}

export default AllowHotalModal;

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    borderRadius: "8px",
    boxShadow: 24,
    p: 4,
    width: "97%",
  };

  const customStyles = {
    control: (provided) => ({
      ...provided,
      borderRadius: "30px",
      backgroundColor: "#b9b5ac",
      opacity: 0.6,
      paddingLeft: "0px",
      border: "none",
      boxShadow: "none",
      marginBottom: "4px",
      marginTop: "4px",
    }),
    menu: (provided) => ({
      ...provided,
      width: 300, // dropdown menu width
    }),
  };
